import { render, staticRenderFns } from "./ProductCategoryCreateDrawer.vue?vue&type=template&id=10a2fb26&scoped=true"
import script from "./ProductCategoryCreateDrawer.vue?vue&type=script&lang=js"
export * from "./ProductCategoryCreateDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a2fb26",
  null
  
)

export default component.exports